import { useSelector } from 'react-redux';
import { Grid, List, ListItem, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { map, orderBy } from 'lodash';
import PropTypes from 'prop-types';

import allergyTypes from 'common/constants/allergyTypes';

const AllergyTable = ({ mpi }) => {
  const theme = useTheme();
  const allergies = useSelector(({ patient }) => patient[mpi]?.medicalHistory?.allergies);

  if (!allergies) {
    return (
      <Typography align='center' sx={{ fontWeight: '500' }}>
        Loading...
      </Typography>
    );
  }

  if (!allergies.length) {
    return (
      <Typography align='center' sx={{ fontWeight: '500' }}>
        No Allergies
      </Typography>
    );
  }

  return (
    <Grid container>
      <Grid
        container
        sx={{ borderBottom: `1px solid ${theme.palette.grey[400]}`, px: 2, py: 1 }}
        gap={1}
      >
        <Grid item xs={12} sm={3} md={2}>
          <Typography sx={{ fontWeight: '500' }}>Allergy Type</Typography>
        </Grid>
        <Grid item xs={12} sm={8} md={9}>
          <Typography sx={{ fontWeight: '500' }}>Description</Typography>
        </Grid>
      </Grid>
      <List sx={{ width: '100%', py: 0 }}>
        {map(orderBy(allergies, ['allergyType'], ['asc']), (allergy) => (
          <Grid
            container
            component={ListItem}
            sx={{
              borderBottom: `1px solid ${theme.palette.grey[200]}`,
              px: 2,
              py: 1,
              '&:hover': { bgcolor: theme.palette.grey[100] },
            }}
            key={allergy.patientAllergyId}
            gap={1}
          >
            <Grid item xs={12} sm={3} md={2}>
              <Typography>{allergyTypes[allergy.allergyType] || allergy.allergyType}</Typography>
            </Grid>
            <Grid item xs={12} sm={8} md={9}>
              <Typography>{allergy.description}</Typography>
            </Grid>
          </Grid>
        ))}
      </List>
    </Grid>
  );
};

AllergyTable.propTypes = {
  mpi: PropTypes.string.isRequired,
};

export default AllergyTable;
